<template>
	<div class="text">
		共搜索到 {{ total }} 条
	</div>
</template>

<script>
export default {
	name: 'TotalIndex',
	props: {
		total: {
			type:[Number,String],
			default: 0
		}
	}
}
</script>

<style lang="less" scoped>
.text {
	font-size: 16px;
	font-family: Source Han Sans SC;
	font-weight: 500;
	color: #6345D5;
}
</style>